import { getRequest, patchRequest } from 'services/requests';

const services = {
    getUser: (id) => getRequest(`/users/${id}`),
    updateUser: (id, body) => patchRequest(`/users/${id}`, body),
};

export default services;
